module.exports = __webpack_public_path__ + "static/media/Bullhorn.c21cda4e.svg";